import {Typography, useTheme} from "@mui/material";
import {ProcessDatePicker} from "components";

import {useFormContext, Controller} from "react-hook-form";
import useValidateVoyages from "views/ProcessDetails/hooks/useValidateVoyages";
import {Process} from "views/ProcessDetails/refactor/types/process.types";
import {Voyage} from "views/ProcessDetails/refactor/types/voyages.types";

type Props = {
  index: number;
  disabled: boolean;
  allVoyages: Voyage[];
};

const VoyageLoadField = (props: Props) => {
  const {index, disabled, allVoyages} = props;
  const {control} = useFormContext<Process>();
  const {
    validateLoadMaxDate,
    minDateVoyageLoad,
    maxDateVoyageLoad,
    shouldDisableLoad,
  } = useValidateVoyages();

  const theme = useTheme();

  return (
    <Controller
      name={
        `boarding.voyages.${index}.cargoLoad` as `boarding.voyages.0.cargoLoad`
      }
      control={control}
      rules={{
        validate: (value) => {
          return validateLoadMaxDate(value ?? "", index, allVoyages);
        },
      }}
      render={({field: {value}}) => (
        <>
          <ProcessDatePicker
            value={value}
            name={`boarding.voyages.${index}.cargoLoad`}
            errorName="Embarque"
            minDate={minDateVoyageLoad(index, allVoyages)?.date}
            title={`Embarque viagem ${index + 1}`}
            maxDate={maxDateVoyageLoad(index, allVoyages)?.date}
            //Em algum momento isso tava desabilitado, hoje não está mais, não sei o motivo e precisa de testes por motivos de Fuso caso seja habilitado.
            // disableFuture={true}
            disabled={
              disabled || shouldDisableLoad(index, allVoyages)?.disabled //apague o && value
            }
            helperText={
              maxDateVoyageLoad(index, allVoyages)?.message ??
              minDateVoyageLoad(index, allVoyages)?.message ??
              "Data superior ao dia de hoje"
            }
            fullWidth
            label="Embarque"
          />
          {shouldDisableLoad(index, allVoyages)?.message && (
            <Typography variant="subtitle3" color={theme.palette.primary.main}>
              {shouldDisableLoad(index, allVoyages)?.message}
            </Typography>
          )}
        </>
      )}
    />
  );
};

export default VoyageLoadField;
